import { MetaDataState } from 'interfaces/meta'
import { Reducer } from 'interfaces'
import { normalizeMeta } from 'helpers/rawHelpers'
// tslint:disable-next-line
const RAW_META = require('fixtures/meta.json')
const INITIAL_STATE = normalizeMeta(RAW_META)
const metaReducer: Reducer<MetaDataState> = (state = INITIAL_STATE) => {
  return state
}

export default metaReducer
